import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, vModelRadio as _vModelRadio, normalizeClass as _normalizeClass, vModelSelect as _vModelSelect, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-0e0d2fca"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white add-support-cours-card" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "text-black fw-semibold" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_6 = {
  key: 0,
  class: "row gx-3 mb-4"
}
const _hoisted_7 = { class: "col-md-12" }
const _hoisted_8 = { class: "alert alert-info" }
const _hoisted_9 = { class: "mb-0" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_11 = { class: "border border-warning mb-10 mt-10" }
const _hoisted_12 = { class: "row d-flex align-items-center justify-content-between fw-bold py-2 bg-warning" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-7" }, [
  /*#__PURE__*/_createElementVNode("h4", { class: "fs-4 text-white" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-video me-2" }),
    /*#__PURE__*/_createTextVNode(" Collection de vidéos ")
  ])
], -1))
const _hoisted_14 = { class: "col-md-5" }
const _hoisted_15 = { class: "d-flex float-end" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-plus-circle me-1 fs-12" }, null, -1))
const _hoisted_17 = { class: "p-3" }
const _hoisted_18 = {
  key: 0,
  class: "text-center text-muted py-3"
}
const _hoisted_19 = {
  key: 0,
  class: "row mt-10"
}
const _hoisted_20 = /*#__PURE__*/_createStaticVNode("<div class=\"col-md-3\" data-v-0e0d2fca><label class=\"d-block text-black fw-semibold mb-10\" data-v-0e0d2fca>Titre <span class=\"text-danger\" data-v-0e0d2fca>*</span></label></div><div class=\"col-md-4\" data-v-0e0d2fca><label class=\"d-block text-black fw-semibold mb-10\" data-v-0e0d2fca>URL / Fichier <span class=\"text-danger\" data-v-0e0d2fca>*</span></label></div><div class=\"col-md-4\" data-v-0e0d2fca><label class=\"d-block text-black fw-semibold mb-10\" data-v-0e0d2fca>Description</label></div><div class=\"col-md-1\" data-v-0e0d2fca><label class=\"d-block text-black fw-semibold mb-10\" data-v-0e0d2fca>Action</label></div>", 4)
const _hoisted_24 = [
  _hoisted_20
]
const _hoisted_25 = { class: "col-md-3" }
const _hoisted_26 = ["onUpdate:modelValue", "disabled"]
const _hoisted_27 = { class: "col-md-4" }
const _hoisted_28 = {
  key: 0,
  class: "d-flex gap-2 mb-1"
}
const _hoisted_29 = { class: "form-check" }
const _hoisted_30 = ["name", "onUpdate:modelValue"]
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-check-label" }, "URL", -1))
const _hoisted_32 = { class: "form-check ms-2" }
const _hoisted_33 = ["name", "onUpdate:modelValue"]
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-check-label" }, "Fichier", -1))
const _hoisted_35 = ["onUpdate:modelValue"]
const _hoisted_36 = { key: 2 }
const _hoisted_37 = ["onChange"]
const _hoisted_38 = {
  key: 0,
  class: "text-success d-block mt-1"
}
const _hoisted_39 = {
  key: 1,
  class: "text-muted d-block mt-1"
}
const _hoisted_40 = {
  key: 3,
  class: "badge bg-danger"
}
const _hoisted_41 = { class: "col-md-4" }
const _hoisted_42 = ["onUpdate:modelValue", "disabled"]
const _hoisted_43 = { class: "col-md-1 pt-1 d-flex justify-content-center align-items-center" }
const _hoisted_44 = ["onClick", "title"]
const _hoisted_45 = ["onClick"]
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-times" }, null, -1))
const _hoisted_47 = [
  _hoisted_46
]
const _hoisted_48 = {
  key: 1,
  class: "my-2"
}
const _hoisted_49 = { class: "border border-info mb-10 mt-10" }
const _hoisted_50 = { class: "row d-flex align-items-center justify-content-between fw-bold py-2 bg-info" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-7" }, [
  /*#__PURE__*/_createElementVNode("h4", { class: "fs-4 text-white" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-file-alt me-2" }),
    /*#__PURE__*/_createTextVNode(" Collection de textes ")
  ])
], -1))
const _hoisted_52 = { class: "col-md-5" }
const _hoisted_53 = { class: "d-flex float-end" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-plus-circle me-1 fs-12" }, null, -1))
const _hoisted_55 = { class: "p-3" }
const _hoisted_56 = {
  key: 0,
  class: "text-center text-muted py-3"
}
const _hoisted_57 = {
  key: 0,
  class: "row mt-10"
}
const _hoisted_58 = /*#__PURE__*/_createStaticVNode("<div class=\"col-md-4\" data-v-0e0d2fca><label class=\"d-block text-black fw-semibold mb-10\" data-v-0e0d2fca>Titre <span class=\"text-danger\" data-v-0e0d2fca>*</span></label></div><div class=\"col-md-2\" data-v-0e0d2fca><label class=\"d-block text-black fw-semibold mb-10\" data-v-0e0d2fca>Type</label></div><div class=\"col-md-5\" data-v-0e0d2fca><label class=\"d-block text-black fw-semibold mb-10\" data-v-0e0d2fca>Fichier <span class=\"text-danger\" data-v-0e0d2fca>*</span></label></div><div class=\"col-md-1\" data-v-0e0d2fca><label class=\"d-block text-black fw-semibold mb-10\" data-v-0e0d2fca>Action</label></div>", 4)
const _hoisted_62 = [
  _hoisted_58
]
const _hoisted_63 = { class: "col-md-4" }
const _hoisted_64 = ["onUpdate:modelValue", "disabled"]
const _hoisted_65 = { class: "col-md-2" }
const _hoisted_66 = ["onUpdate:modelValue", "disabled"]
const _hoisted_67 = /*#__PURE__*/_createStaticVNode("<option value=\"note\" data-v-0e0d2fca>Note</option><option value=\"resume\" data-v-0e0d2fca>Résumé</option><option value=\"definition\" data-v-0e0d2fca>Définition</option><option value=\"exercice\" data-v-0e0d2fca>Exercice</option><option value=\"autre\" data-v-0e0d2fca>Autre</option>", 5)
const _hoisted_72 = [
  _hoisted_67
]
const _hoisted_73 = { class: "col-md-5" }
const _hoisted_74 = { key: 0 }
const _hoisted_75 = ["onChange"]
const _hoisted_76 = {
  key: 0,
  class: "text-success d-block mt-1"
}
const _hoisted_77 = {
  key: 1,
  class: "text-muted d-block mt-1"
}
const _hoisted_78 = {
  key: 1,
  class: "badge bg-danger"
}
const _hoisted_79 = { class: "col-md-1 pt-1 d-flex justify-content-center align-items-center" }
const _hoisted_80 = ["onClick", "title"]
const _hoisted_81 = ["onClick"]
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-times" }, null, -1))
const _hoisted_83 = [
  _hoisted_82
]
const _hoisted_84 = {
  key: 1,
  class: "my-2"
}
const _hoisted_85 = { class: "row mt-5" }
const _hoisted_86 = { class: "col-md-12" }
const _hoisted_87 = { class: "d-flex align-items-center" }
const _hoisted_88 = ["disabled"]
const _hoisted_89 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-2"
}
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-delete lh-1 me-1 position-relative top-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", _hoisted_3, [
        _createTextVNode(" Modifier les collections du support "),
        (_ctx.support)
          ? (_openBlock(), _createElementBlock("span", _hoisted_4, ": " + _toDisplayString(_ctx.support.titre), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      (_ctx.support)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("p", _hoisted_9, [
                  _createTextVNode(" Modification des médias pour : "),
                  _createElementVNode("strong", null, _toDisplayString(_ctx.support.titre), 1),
                  _hoisted_10,
                  _createTextVNode(" Auteur : "),
                  _createElementVNode("strong", null, _toDisplayString(_ctx.support.auteur || 'N/A'), 1)
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("form", {
        onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.updateSupportMedias && _ctx.updateSupportMedias(...args)), ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("button", {
                  class: "btn btn-light",
                  type: "button",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.addVideo && _ctx.addVideo(...args)))
                }, [
                  _hoisted_16,
                  _createTextVNode(" Ajouter une vidéo ")
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            (_ctx.videos.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, " Aucune vidéo. Cliquez sur \"Ajouter une vidéo\" pour en ajouter. "))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.videos, (video, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: video.tempId || index
              }, [
                (index === 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, _hoisted_24))
                  : _createCommentVNode("", true),
                _createElementVNode("div", {
                  class: _normalizeClass(["row mb-10 align-items-start", { 'opacity-50': video._toDelete }])
                }, [
                  _createElementVNode("div", _hoisted_25, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control shadow-none fs-md-15 text-black",
                      placeholder: "Ex: Introduction au chapitre 1",
                      "onUpdate:modelValue": ($event: any) => ((video.titre) = $event),
                      disabled: video._toDelete
                    }, null, 8, _hoisted_26), [
                      [_vModelText, video.titre]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_27, [
                    (!video._toDelete)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                          _createElementVNode("div", _hoisted_29, [
                            _withDirectives(_createElementVNode("input", {
                              class: "form-check-input",
                              type: "radio",
                              name: `videoSource_${index}`,
                              value: "url",
                              "onUpdate:modelValue": ($event: any) => ((video.sourceType) = $event)
                            }, null, 8, _hoisted_30), [
                              [_vModelRadio, video.sourceType]
                            ]),
                            _hoisted_31
                          ]),
                          _createElementVNode("div", _hoisted_32, [
                            _withDirectives(_createElementVNode("input", {
                              class: "form-check-input",
                              type: "radio",
                              name: `videoSource_${index}`,
                              value: "fichier",
                              "onUpdate:modelValue": ($event: any) => ((video.sourceType) = $event)
                            }, null, 8, _hoisted_33), [
                              [_vModelRadio, video.sourceType]
                            ]),
                            _hoisted_34
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (video.sourceType === 'url' && !video._toDelete)
                      ? _withDirectives((_openBlock(), _createElementBlock("input", {
                          key: 1,
                          type: "url",
                          class: "form-control shadow-none fs-md-15 text-black",
                          placeholder: "https://youtube.com/...",
                          "onUpdate:modelValue": ($event: any) => ((video.url) = $event)
                        }, null, 8, _hoisted_35)), [
                          [_vModelText, video.url]
                        ])
                      : (video.sourceType === 'fichier' && !video._toDelete)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                            _createElementVNode("input", {
                              type: "file",
                              accept: "video/*",
                              class: "form-control shadow-none fs-md-15 text-black",
                              onChange: (e) => _ctx.onVideoFichierChange(index, e)
                            }, null, 40, _hoisted_37),
                            (video.fichierName)
                              ? (_openBlock(), _createElementBlock("small", _hoisted_38, _toDisplayString(video.fichierName), 1))
                              : _createCommentVNode("", true),
                            (video.id && video.lienActuel && !video.fichier)
                              ? (_openBlock(), _createElementBlock("small", _hoisted_39, " Fichier actuel : " + _toDisplayString(video.lienActuel), 1))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true),
                    (video._toDelete)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_40, "Sera supprimé"))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_41, [
                    _withDirectives(_createElementVNode("textarea", {
                      class: "form-control shadow-none fs-md-15 text-black",
                      rows: "2",
                      placeholder: "Description courte (optionnel)",
                      "onUpdate:modelValue": ($event: any) => ((video.description) = $event),
                      disabled: video._toDelete
                    }, null, 8, _hoisted_42), [
                      [_vModelText, video.description]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_43, [
                    (video.id)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          class: _normalizeClass(["btn btn-sm border-0 w-100", video._toDelete ? 'btn-secondary' : 'btn-warning']),
                          type: "button",
                          onClick: ($event: any) => (_ctx.toggleDeleteVideo(index)),
                          title: video._toDelete ? 'Annuler la suppression' : 'Marquer pour suppression'
                        }, [
                          _createElementVNode("i", {
                            class: _normalizeClass(video._toDelete ? 'fas fa-undo' : 'fas fa-trash')
                          }, null, 2)
                        ], 10, _hoisted_44))
                      : (_openBlock(), _createElementBlock("button", {
                          key: 1,
                          class: "btn btn-sm btn-danger border-0 w-100",
                          type: "button",
                          onClick: ($event: any) => (_ctx.removeVideo(index))
                        }, _hoisted_47, 8, _hoisted_45))
                  ])
                ], 2),
                (index < _ctx.videos.length - 1)
                  ? (_openBlock(), _createElementBlock("hr", _hoisted_48))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_49, [
          _createElementVNode("div", _hoisted_50, [
            _hoisted_51,
            _createElementVNode("div", _hoisted_52, [
              _createElementVNode("div", _hoisted_53, [
                _createElementVNode("button", {
                  class: "btn btn-light",
                  type: "button",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.addTexte && _ctx.addTexte(...args)))
                }, [
                  _hoisted_54,
                  _createTextVNode(" Ajouter un texte ")
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_55, [
            (_ctx.textes.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_56, " Aucun texte. Cliquez sur \"Ajouter un texte\" pour en ajouter. "))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.textes, (texte, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: texte.tempId || index
              }, [
                (index === 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_57, _hoisted_62))
                  : _createCommentVNode("", true),
                _createElementVNode("div", {
                  class: _normalizeClass(["row mb-10 align-items-start", { 'opacity-50': texte._toDelete }])
                }, [
                  _createElementVNode("div", _hoisted_63, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control shadow-none fs-md-15 text-black",
                      placeholder: "Ex: Résumé du chapitre 1",
                      "onUpdate:modelValue": ($event: any) => ((texte.titre) = $event),
                      disabled: texte._toDelete
                    }, null, 8, _hoisted_64), [
                      [_vModelText, texte.titre]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_65, [
                    _withDirectives(_createElementVNode("select", {
                      class: "form-select shadow-none fs-md-15 text-black",
                      "onUpdate:modelValue": ($event: any) => ((texte.type) = $event),
                      disabled: texte._toDelete
                    }, _hoisted_72, 8, _hoisted_66), [
                      [_vModelSelect, texte.type]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_73, [
                    (!texte._toDelete)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_74, [
                          _createElementVNode("input", {
                            type: "file",
                            class: "form-control shadow-none fs-md-15 text-black",
                            accept: ".pdf,.doc,.docx,.txt",
                            onChange: ($event: any) => (_ctx.handleTexteFileUpload($event, index))
                          }, null, 40, _hoisted_75),
                          (texte.fichierName)
                            ? (_openBlock(), _createElementBlock("small", _hoisted_76, " Nouveau : " + _toDisplayString(texte.fichierName), 1))
                            : _createCommentVNode("", true),
                          (texte.id && texte.lienActuel && !texte.fichier)
                            ? (_openBlock(), _createElementBlock("small", _hoisted_77, " Fichier actuel : " + _toDisplayString(texte.lienActuel), 1))
                            : _createCommentVNode("", true)
                        ]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_78, "Sera supprimé"))
                  ]),
                  _createElementVNode("div", _hoisted_79, [
                    (texte.id)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          class: _normalizeClass(["btn btn-sm transition border-0 w-100", texte._toDelete ? 'btn-secondary' : 'btn-warning']),
                          type: "button",
                          onClick: ($event: any) => (_ctx.toggleDeleteTexte(index)),
                          title: texte._toDelete ? 'Annuler la suppression' : 'Marquer pour suppression'
                        }, [
                          _createElementVNode("i", {
                            class: _normalizeClass(texte._toDelete ? 'fas fa-undo' : 'fas fa-trash')
                          }, null, 2)
                        ], 10, _hoisted_80))
                      : (_openBlock(), _createElementBlock("button", {
                          key: 1,
                          class: "btn btn-sm btn-danger transition border-0 w-100",
                          type: "button",
                          onClick: ($event: any) => (_ctx.removeTexte(index))
                        }, _hoisted_83, 8, _hoisted_81))
                  ])
                ], 2),
                (index < _ctx.textes.length - 1)
                  ? (_openBlock(), _createElementBlock("hr", _hoisted_84))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_85, [
          _createElementVNode("div", _hoisted_86, [
            _createElementVNode("div", _hoisted_87, [
              _createElementVNode("button", {
                class: "default-btn me-20 transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 rounded-1 fs-md-15 fs-lg-16 bg-success",
                type: "submit",
                disabled: _ctx.isSubmitting
              }, [
                (_ctx.isSubmitting)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_89))
                  : _createCommentVNode("", true),
                _createTextVNode(" " + _toDisplayString(_ctx.isSubmitting ? 'Enregistrement...' : 'Sauvegarder les modifications'), 1)
              ], 8, _hoisted_88),
              _createVNode(_component_router_link, {
                to: "/view-support",
                class: "btn btn-danger transition border-0 lh-1 fw-medium"
              }, {
                default: _withCtx(() => [
                  _hoisted_90,
                  _createTextVNode(" Annuler ")
                ]),
                _: 1
              })
            ])
          ])
        ])
      ], 32)
    ])
  ]))
}